import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { CursosService } from 'src/app/services/cursos.service';
import { AlertController, NumericValueAccessor } from '@ionic/angular';
import { Router } from '@angular/router';
import { GlobalsService } from 'src/app/api/globals.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-crear-curso-estudiante',
  templateUrl: './crear-curso-estudiante.component.html',
  styleUrls: ['./crear-curso-estudiante.component.scss'],
})
export class CrearCursoEstudianteComponent implements OnInit {
  @Input() public curso: any;
  
  

  public host = environment.host;
  public config = {
    language: 'es',
    //plugins: [Alignment],
    toolbar: [
    'heading', '|',
    'bold', 'italic', 'undo', 'redo', 'blockQuote', 'link', '|',
    'numberedList', 'bulletedList', '|','underline'
    ],
    alignment: {
      options: ['left', 'right', 'center', 'justify']
    },
    removePlugins: ['insert']
  };
  public minCal:any = [];
  formGroup: FormGroup;
  defaultImg:string;
  defaultImgFile:any;
  detalles:any;
  materia:any;
  nivel:any;
  tituloNombre:any;
  tituloNombreUser:any;
  formControlName:any;
  id:number;
  auth_key:string;
  nivelesAcademicos:any = [];
  materiasAcademicas:any = [];
  displayUserData:any;
  ismobile;

  submit:boolean = false;


  tinyMCEConfiguration;
  edittext = false;
  constructor(
    private sanitizer:DomSanitizer,
    private el: ElementRef,
    private authService: AuthService,
    private cursosService: CursosService,
    public alertController: AlertController,
    private router:Router,
    public globalsService: GlobalsService,
  ) {
    console.log("🚀 ~ CrearCursoEstudianteComponent ~ curso:", this.curso)
    this.tinyMCEConfiguration ={
      base_url: '/tinymce', 
      suffix: '.min',
      plugins: 'autoresize',
      max_height: 350   
    }
    this.ismobile = globalsService.isMobile;
   }
  
   idcalificacion:number;
   rangocalificacion:string;
  public callifMIn = "";
  
  initForm(){

    this.idcalificacion = this.curso.id_calificacion;
    this.formGroup = new FormGroup({
      detalles: new FormControl(this.curso.descripcion,[Validators.required,Validators.minLength(2),Validators.maxLength(1000)]),
      materia: new FormControl(this.curso.materia_id+'',[Validators.required,Validators.minLength(1),Validators.maxLength(255)]),
      nivel: new FormControl(this.curso.nivel_id+'',[Validators.required,Validators.minLength(1),Validators.maxLength(255)]),
      cursoportada: new FormControl('',[]),
      defaultImgFile: new FormControl('',[]),
      nombre:new FormControl(this.curso.nombre,[]),
      titulo:new FormControl(this.tituloNombre,[]),
      calificacionmin:new FormControl(this.curso.calificacion_min+'',[Validators.required,Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')]),
      rangocalificacion:new FormControl('',[]),
      idcalificacion:new FormControl(this.idcalificacion+'',[Validators.required]),
      idcurso:new FormControl(this.curso.id+'',[Validators.required]),
    });
  }
  

  ngOnInit() {
    console.log('Curso data: ',this.curso);
    
    this.authService.userData$.subscribe((res: any) => {
      if(!this.displayUserData){
        this.displayUserData =  res;
        this.loadVariables();
        this.loadMaterias();
        this.loadNiveles();
        this.loadCalificacionesMaxMin();
        this.initForm();
      }
    });
  }
  initVariables(){
    this.defaultImg = "assets/imagenes/sistema/no-image.png";
    if(this.curso.imagen)
    this.defaultImg = this.host+'/'+this.curso.imagen;
    this.formControlName = "";
    this.materia = "";
    this.nivel = "";
    this.defaultImgFile = null;
    this.nivelesAcademicos = [];
    this.materiasAcademicas = [];
    this.submit = false;
  }
  loadVariables(){
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
    this.defaultImg = "assets/imagenes/sistema/no-image.png";
    if(this.curso.imagen)
    this.defaultImg = this.host+'/'+this.curso.imagen;
    this.tituloNombre = ""+this.displayUserData?.nombre_apellido;
    
  }
  loadNiveles(){
    if(this.id && this.auth_key)
    this.cursosService.getNiveles(this.id,this.auth_key).subscribe(res=>{
      if(res){
        this.nivelesAcademicos = res;
      }
    });
  }
  loadMaterias(){
    if(this.id && this.auth_key)
    this.cursosService.getMaterias(this.id,this.auth_key).subscribe(res=>{
      if(res){
        this.materiasAcademicas = res;
      }
    });
  }
  loadCalificacionesMaxMin(){
    if(this.id && this.auth_key)
    this.cursosService.getCalificacionesMaxMin(this.id,this.auth_key).subscribe(res=>{
      if(res){
        this.minCal = res;
        
      }
    });
  }
  
  setCalMin(id,elememt){
    
    let color = "";
    let elems:any = document.getElementsByClassName('calfmin');
    
    for(let i = 0; i < elems.length; i++){
      elems[i].style = "--background:var(--ion-color-light); color:var(--ion-color-light-contrast);";
    }
    this.minCal.forEach(elem => {
      if(elem.id == id){
        color = elem.color;
        let el:any=document.getElementById(elememt);
        el.style = "--background:var("+color+")";
        this.callifMIn = elem.nombre;
        this.formGroup.get('rangocalificacion').setValue(this.callifMIn);
        this.formGroup.get('idcalificacion').setValue(elem.id);
      }
    });
  }
  styleCalificacion(id){
    let color = "--ion-color-light";
    let style = '--background:var(--ion-color-light);color:var(--ion-color-light-contrast)'
    
    this.minCal.forEach(elem => {
      if(elem.id == id && this.idcalificacion == id){
        color = elem.color;
        this.rangocalificacion = elem.nombre;
      }
    });//--background:var(--ion-color-light);color:var(--ion-color-light-contrast);
    if(color != '--ion-color-light'){
      style ='--background:var('+color+')';
    }
    return style;
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid input, form .ng-invalid textarea"
    );
    firstInvalidControl.focus();
  }

  uploadFileCurso(event: EventTarget) {
    let eventObj: any = event;
    let target: HTMLInputElement = eventObj.target as HTMLInputElement;
    let file: File = target.files[0];
    let _this = this;
    var reader = new FileReader();
    reader.onload = function (e:any) {
        _this.defaultImg = e.target.result;
        _this.defaultImgFile = file;         
    }
    reader.readAsDataURL(file);
  }


  async presentAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: '¡Felicidades, has creado el curso!',
      message: 'Por favor recuerda que tu curso pasara por un proceso de revisión y en el momento que sea aprobado será publicado en Cronoleo, nos alegra que crees contenido',
      buttons: [{
        text: 'Aceptar',
        cssClass: 'alert-button my-custom-button'  
      }]
    });
    this.initVariables();
    this.initForm();
    await alert.present();
    const { role } = await alert.onDidDismiss();
    
    this.router.navigate(['/cursos']);
  }

  ionViewWillLeave() {
    this.initVariables();
    this.initForm();
  }

  // public onChange( { editor }: ChangeEvent ) {
  //   const data = editor.getData();
  // }
  
  




  crearCurso(){
    return false;
  }

  editText(){
    this.edittext = !this.edittext;
  }
  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  selectedTextNivel(){
    let nombre = null;
    this.nivelesAcademicos.forEach(orden => {
      if(this.curso.nivel_id == orden.id){
        nombre = orden.nombre;
      }
    });
    return nombre;
  }
  selectedTextMateria(){
    let nombre = null;
    this.materiasAcademicas.forEach(orden => {
      if(this.curso.materia_id == orden.id){
        nombre = orden.materia;
      }
    });
    return nombre;
  }
}
